import { render, staticRenderFns } from "./singledetails.vue?vue&type=template&id=7e47cf0a&scoped=true"
import script from "./singledetails.vue?vue&type=script&lang=js"
export * from "./singledetails.vue?vue&type=script&lang=js"
import style0 from "./singledetails.vue?vue&type=style&index=0&id=7e47cf0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e47cf0a",
  null
  
)

export default component.exports